import CampaignIcon from "assets/icons/mono/CampaignIcon";
import DashboardIcon from "assets/icons/mono/DashboardIcon";
import StarIcon from "assets/icons/mono/StarIcon";
import UserIcon from "assets/icons/mono/UserIcon";
import { PRIVILEGE } from "constants/privilege";
import { useFirebase } from "contexts/FirebaseAuthContext";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "store";
import {query, collection, where, onSnapshot} from "firebase/firestore"

const Navdata = () => {

    const configruations = useSelector((state: RootState) => state.auth.configurations);

    const history = useNavigate();
    //state data
    const [isDashboard, setIsDashboard] = useState(false);
    const [isApps, setIsApps] = useState(false);
    const [isAuth, setIsAuth] = useState(false);
    const [isPages, setIsPages] = useState(false);
    const [isBaseUi, setIsBaseUi] = useState(false);
    const [isAdvanceUi, setIsAdvanceUi] = useState(false);
    const [isForms, setIsForms] = useState(false);
    const [isTables, setIsTables] = useState(false);
    const [isCharts, setIsCharts] = useState(false);
    const [isIcons, setIsIcons] = useState(false);
    const [isMaps, setIsMaps] = useState(false);
    const [isMultiLevel, setIsMultiLevel] = useState(false);

    const [iscurrentState, setIscurrentState] = useState('Dashboard');

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");

                var id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement
                if (getID)
                    getID.classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
        if (iscurrentState !== 'Dashboard') {
            setIsDashboard(false);
        }
        if (iscurrentState !== 'Apps') {
            setIsApps(false);
        }
        if (iscurrentState !== 'Auth') {
            setIsAuth(false);
        }
        if (iscurrentState !== 'Pages') {
            setIsPages(false);
        }
        if (iscurrentState !== 'BaseUi') {
            setIsBaseUi(false);
        }
        if (iscurrentState !== 'AdvanceUi') {
            setIsAdvanceUi(false);
        }
        if (iscurrentState !== 'Forms') {
            setIsForms(false);
        }
        if (iscurrentState !== 'Tables') {
            setIsTables(false);
        }
        if (iscurrentState !== 'Charts') {
            setIsCharts(false);
        }
        if (iscurrentState !== 'Icons') {
            setIsIcons(false);
        }
        if (iscurrentState !== 'Maps') {
            setIsMaps(false);
        }
        if (iscurrentState !== 'MuliLevel') {
            setIsMultiLevel(false);
        }
        if (iscurrentState === 'Widgets') {
            history("/widgets");
            document.body.classList.add('twocolumn-panel');
        }
    }, [
        history,
        iscurrentState,
        isDashboard,
        isApps,
        isAuth,
        isPages,
        isBaseUi,
        isAdvanceUi,
        isForms,
        isTables,
        isCharts,
        isIcons,
        isMaps,
        isMultiLevel
    ]);

    const privileges = useSelector((state: RootState) => state.auth.privileges);

    const hasPrivilege = (privilege: string) => {
        return privileges.includes(privilege);
    }

    const menuItems: any = [
        {
            label: "Menu",
            isHeader: true,
        },
        // {
        //     id: "dashboard",
        //     label: "Dashboard",
        //     icon: "bx bxs-dashboard",
        //     iconSVG: <DashboardIcon />,
        //     link: "/",
        //     stateVariables: isDashboard,
        //     click: function (e: any) {
        //         e.preventDefault();
        //         setIsDashboard(!isDashboard);
        //         setIscurrentState('Dashboard');
        //         updateIconSidebar(e);
        //     },
        //     hasPrivilege: true,
        // },
        {
            id: "campaigns",
            label: "Campaigns",
            icon: "bx bxs-megaphone",
            iconSVG: <CampaignIcon />,
            link: "/campaign",
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('Campaigns');
                updateIconSidebar(e);
            },
            hasPrivilege: hasPrivilege(PRIVILEGE.CAMPAIGN.CAMPAIGN.SHOW),
        },
        {
            id: "collaborations",
            label: "Collaborations",
            icon: "ri-service-fill",
            // iconSVG: <CampaignIcon />,
            link: "/collaboration",
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('collaboration');
                updateIconSidebar(e);
            },
            hasPrivilege: hasPrivilege(PRIVILEGE.CAMPAIGN.COLLABORATION.INDEX),
        },
        {
            id: "content-library",
            label: "Content Library",
            icon: "ri-video-line",
            // iconSVG: <CampaignIcon />,
            link: "/content-library",
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('content-library');
                updateIconSidebar(e);
            },
            hasPrivilege: hasPrivilege(PRIVILEGE.CAMPAIGN.COLLABORATION.INDEX),
        },
        {
            id: "brands",
            label: "Brands",
            icon: "bx bx-buildings",
            iconSVG: <StarIcon />,
            link: "/brand",
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('Brands');
                updateIconSidebar(e);
            },
            hasPrivilege: true,
        },
        {
            id: "users",
            label: "Users",
            icon: "bx bxs-user",
            iconSVG: <UserIcon />,
            link: "/user",
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('Users');
                updateIconSidebar(e);
            },
            hasPrivilege: hasPrivilege(PRIVILEGE.AGENCY.USER.INDEX)
        },
        {
            id: "chat",
            label: "Chat",
            icon: "bx bxs-chat",
            link: "/chat",
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('Chat');
                updateIconSidebar(e);
            },
            hasPrivilege: hasPrivilege(PRIVILEGE.CAMPAIGN.COLLABORATION.INDEX)
        },
        {
            id: "wallet",
            label: "Wallet",
            icon: "bx bxs-wallet-alt",
            link: "/wallet",
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('Wallet');
                updateIconSidebar(e);
            },
            hasPrivilege: hasPrivilege(PRIVILEGE.CAMPAIGN.COLLABORATION.INDEX)
        },
        {
            id: "social-account",
            label: "Social Accounts",
            icon: "bx bxs-user-account",
            link: '/social-account',
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('Social Accounts');
                updateIconSidebar(e);
            },
            hasPrivilege: configruations?.agency_social_connect === 'y'
        },
        {
            id: "creator-marketplace",
            label: "Creator Marketplace",
            icon: "mdi mdi-account-search-outline",
            link: '/creator-marketplace',
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('Social Accounts');
                updateIconSidebar(e);
            },
            hasPrivilege: configruations?.agency_ig_creator_marketplace === 'y'
        }
    ];
    return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;